"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconHelp = void 0;
var React = __importStar(require("react"));
var IconHelp = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M5.958,18.6558 L8.096,16.5188 C9.219,17.4888 10.603,17.9998 12,17.9998 C13.447,17.9998 14.883,17.4608 16.026,16.4198 L18.157,18.5518 C16.482,20.1278 14.31,20.9998 12,20.9998 C9.742,20.9998 7.617,20.1648 5.958,18.6558 L5.958,18.6558 Z M5.449,5.8428 L7.58,7.9738 C5.564,10.1878 5.509,13.5178 7.398,15.8018 L5.256,17.9438 C2.203,14.4828 2.267,9.2278 5.449,5.8428 L5.449,5.8428 Z M17.961,5.2708 L15.797,7.3938 C14.693,6.4828 13.354,5.9998 12,5.9998 C10.693,5.9998 9.401,6.4508 8.319,7.2988 L6.171,5.1508 C7.797,3.7628 9.838,2.9998 12,2.9998 C14.221,2.9998 16.314,3.8078 17.961,5.2708 L17.961,5.2708 Z M7,11.9998 C7,10.6648 7.52,9.4088 8.464,8.4648 C9.409,7.5198 10.665,6.9998 12,6.9998 C13.335,6.9998 14.591,7.5198 15.536,8.4648 C16.48,9.4088 17,10.6648 17,11.9998 C17,13.3358 16.48,14.5918 15.536,15.5358 C14.591,16.4798 13.335,16.9998 12,16.9998 C10.665,16.9998 9.409,16.4798 8.464,15.5358 C7.52,14.5918 7,13.3358 7,11.9998 L7,11.9998 Z M16.701,15.6808 C18.458,13.4398 18.397,10.2638 16.515,8.0908 L18.67,5.9748 C21.698,9.3248 21.759,14.4108 18.848,17.8278 L16.701,15.6808 Z M19.071,4.9288 C17.119,2.9768 14.559,1.9998 12,1.9998 C9.441,1.9998 6.881,2.9768 4.929,4.9288 C1.023,8.8338 1.023,15.1658 4.929,19.0718 C6.881,21.0238 9.441,21.9998 12,21.9998 C14.559,21.9998 17.119,21.0238 19.071,19.0718 C22.977,15.1658 22.977,8.8338 19.071,4.9288 L19.071,4.9288 Z" }))); };
exports.IconHelp = IconHelp;
exports.IconHelp.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconHelp;
